import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Close"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "close"
    }}>{`Close`}</h1>
    <p>{`Button with close (×) icon.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import { Close } from 'theme-ui'
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live=true",
        "live": "true"
      }}>{`<Close />
`}</code></pre>
    <p>{`The `}<inlineCode parentName="p">{`Close`}</inlineCode>{` component renders as a `}<inlineCode parentName="p">{`<button>`}</inlineCode>{` element by default. Pass any button attributes as props to the component.`}</p>
    <h2 {...{
      "id": "variants"
    }}>{`Variants`}</h2>
    <p>{`Close component variants can be defined in the `}<inlineCode parentName="p">{`theme.buttons`}</inlineCode>{` object.
The Close component uses `}<inlineCode parentName="p">{`theme.buttons.close`}</inlineCode>{` as its default variant style.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// example theme variants
{
  buttons: {
    close: {
      color: 'primary',
    }
  }
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      